import {Component, ElementRef, OnInit, Renderer2, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {ContactUsService} from '../../../shared/services/contact-us.service';
import {AlertService} from '../../../shared/services/alert.service';
import {Meta, Title} from "@angular/platform-browser";


@Component({
    selector: 'app-mobile-application-development',
    templateUrl: './mobile-application-development.component.html',
    styleUrls: ['./mobile-application-development.component.scss']
})
export class MobileApplicationDevelopmentComponent implements OnInit {

    @ViewChild('contactFormModal') contactFormModal!: TemplateRef<any>;
    @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
    isModalOpen = false;
    contactForm: FormGroup;
    submitted: any = false;
    submitting: any = false;
    successMessage: string;
    modules = [
        {text: 'Admissions Management'},
        {text: 'Attendance Management'},
        {text: 'Fees Management'},
        {text: 'Exams Management'},
        {text: 'Library Management'},
        {text: 'Payroll Management'},
        {text: 'Organized Department'},
        {text: 'Record Management'},
    ];
    features = [
        {icon: 'assets/img/landing-new/argus/monitoring.png', text: 'Custom App Design'},
        {icon: 'assets/img/landing-new/argus/analytics.png', text: 'Cross-Platform Compatibility'},
        {icon: 'assets/img/landing-new/argus/custom.png', text: 'User-Friendly Interface'},
        {icon: 'assets/img/landing-new/argus/user.png', text: 'High Performance'},
        {icon: 'assets/img/landing-new/argus/multi.png', text: 'Scalability'},
        {icon: 'assets/img/landing-new/argus/hybrid.png', text: 'Security Features'},
        {icon: 'assets/img/landing-new/argus/automated.png', text: 'Push Notifications'},
        {icon: 'assets/img/landing-new/argus/scalability.png', text: 'Integration with Business Tools'},
        {icon: 'assets/img/services/ongoing_support.jpeg', text: 'Ongoing Support and Updates'}

    ];
    whyChoose = [
        {
            header: 'Tailored to Your Needs ',
            text: 'To meet specific business goals, we design the mobile application as per the brand’s unique approach. We provide tailored solutions that deliver results whether it’s about sales, customer engagement, or streamlining operations. '
        },
        {
            header: 'User-Centric Designs',
            text: 'Our applications are intuitive, visually appealing, and easy to navigate. We prioritize user-centric designs, ensure that the users stay engaged and keep coming back, making your app a powerful tool for your brand. '
        },
        {
            header: 'Cross-Platform Compatibility',
            text: 'Our main focus is to expand your reach to a wider audience by developing apps for Android and iOS that offer business growth. With absolute performance across devices, you get the best results without compromising on quality. '
        },
        {
            header: 'Fast Development and Deployment ',
            text: ' We believe ‘Time is Money.’ We ensure a streamlined and fast development and deployment without worrying about the quality and credibility of the application. So you can launch your app on time and start reaping the benefits faster. '
        },
        {
            header: 'Ongoing Support and Maintenance',
            text: 'Our commitment is beyond the delivery. We provide continuous support to our clients, ensure your app stays relevant, secure, and optimized as your business evolves and the tech landscape changes.'
        },
    ];
    offerings = [
        {
            text: 'Requirements Analysis'
        },
        {
            text: 'UI/UX Design'
        },
        {
            text: 'Development and Integration'
        },
        {
            text: 'Quality Assurance and Testing'
        },
        {
            text: 'Deployment and Launch'
        },
    ];


    cards = [
        { image: 'assets/image1.jpg', title: 'Card 1', description: 'Description 1' },
        { image: 'assets/image2.jpg', title: 'Card 2', description: 'Description 2' },
        { image: 'assets/image3.jpg', title: 'Card 3', description: 'Description 3' },
        { image: 'assets/image4.jpg', title: 'Card 4', description: 'Description 4' }
    ];

    slideConfig = {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: true,
        centerMode: true,
        centerPadding: '40px',
    };
    slidersItem = [
        {
            title: 'Tailored to Your Needs ',
            text : 'To meet specific business goals, we design the mobile application as per the brand’s unique approach. We provide tailored solutions that deliver results whether it’s about sales, customer engagement, or streamlining operations'
        },
        {
            title: 'User-Centric Designs  ',
            text : ' Our applications are intuitive, visually appealing, and easy to navigate. We prioritize user-centric designs, ensure that the users stay engaged and keep coming back, making your app a powerful tool for your brand. '
        },
        {
            title: 'Cross-Platform Compatibility',
            text : 'Our main focus is to expand your reach to a wider audience by developing apps for Android and iOS that offer business growth. With absolute performance across devices, you get the best results without compromising on quality. '
        },
        {
            title: 'Fast Development and Deployment ',
            text : 'We believe ‘Time is Money.’ We ensure a streamlined and fast development and deployment without worrying about the quality and credibility of the application. So you can launch your app on time and start reaping the benefits faster.  '
        },
        {
            title: 'Ongoing Support and Maintenance ',
            text : 'Our commitment is beyond the delivery. We provide continuous support to our clients, ensure your app stays relevant, secure, and optimized as your business evolves and the tech landscape changes.'
        },


    ];
    currentIndex = 0;

    selectedIndex: number = 0;

    tabs = [
        { title: 'Enhanced User Engagement', content: 'Our main focus is to create an App that is user-friendly and intuitive, keeps the users hooked with your business or service. Moreover, in-app messages, push notifications, and customized reminders will transform the users into loyal customers.' },
        { title: 'Valuable Data Insights', content: 'Being the foremost mobile application development company, it is our responsibility to provide accurate insights about the behavior of users. The data helps to utilize marketing tactics, purchasing trends, and pinpoint areas for better decision-making.' },
        { title: 'Competitive Features', content: 'Getting your business online helps to upgrade the level of your brand, a comprehensive mobile application is one of the most rational options. Our developers leverage innovative features that show you’re dedicated to customer satisfaction.' },
        { title: 'Streamlined Operations', content: 'Pursuing a mobile app instead of a website is easier and more efficient for mobile browsers. Thus, our crafted app prioritizes mobile users, ensures quicker load time and seamless navigation. We work to simplify workflows and improve efficiency with custom functionalities.' }
    ];

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private contactService: ContactUsService,
        private alertService: AlertService,
        private title: Title,
        private meta: Meta,
        private renderer: Renderer2
    ) {
    }
    ngOnInit(): void {
        this.updateMetaTags();
        this.refresh();
    }

    refresh() {
        this.contactForm = this.fb.group({
            name: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            contact: [''],
            subject: ['', Validators.required],
            message: ['', Validators.required]
        });
        this.schema();
    }

    schema() {
        const corporationSchema = {
            "@context": "https://schema.org",
            "@type": "Mobile-Application-DevelopmentPage",
            "name": "Volmint Technology - Mobile-Application-Development",
            "url": "https://www.volmint.com/mobile-application-development",
            "logo": "https://www.volmint.com/assets/img/white-volmint-logo.png",

        };

        // FAQ Schema
        const faqSchema = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "What platforms do you develop mobile applications for?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "We develop mobile applications for both iOS and Android platforms, ensuring your app  reaches a wide audience and provides a seamless experience across all devices."
                    }
                },
                {
                    "@type": "Question",
                    "name": " How long does it take to develop a mobile application?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "   The development timeline varies based on the complexity and features of the application. On average, a basic mobile app can take between 3 to 6 months, while more complex  applications may require additional time for design, development, and testing."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Will my mobile application be secure?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Absolutely! We prioritize security throughout the development process by implementing the latest security protocols and best practices to protect your app and user data from  potential threats."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can I update my mobile application after it’s launched?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Yes, you can! We provide ongoing support and maintenance services, allowing you to  update your app with new features, enhancements, and security patches as needed to keep  it current and effective."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How much does it cost to develop a mobile application?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The cost of developing a mobile application depends on various factors, including\n" + "                                complexity, design, features, and the platforms chosen. We offer customized solutions\n" +
                            "                                tailored to your budget and requirements, and we're happy to provide a detailed proposal\n" +
                            "                                after discussing your specific needs."
                    }
                },


            ]
        };

        // Add Corporation Schema
        const corpScript: HTMLScriptElement = this.renderer.createElement('script');
        corpScript.type = 'application/ld+json';
        corpScript.text = JSON.stringify(corporationSchema);
        this.renderer.appendChild(document.head, corpScript);

        // Add FAQ Schema
        const faqScript: HTMLScriptElement = this.renderer.createElement('script');
        faqScript.type = 'application/ld+json';
        faqScript.text = JSON.stringify(faqSchema);
        this.renderer.appendChild(document.head, faqScript);
    }

    openModal() {
        this.isModalOpen = true;
    }

    closeModal() {
        this.isModalOpen = false;
    }

    handleOverlayClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (!target.closest('.modal-dialog')) {
            this.closeModal();
        }
    }

    submit() {
        this.submitted = true;
        if (!this.contactForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().name) ? this.contactForm.getRawValue().name : '',
                'email': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().email) ? this.contactForm.getRawValue().email : '',
                'contact': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().contact) ? this.contactForm.getRawValue().contact : '',
                'subject': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().subject) ? this.contactForm.getRawValue().subject : '',
                'message': (this.contactForm && this.contactForm.getRawValue() && this.contactForm.getRawValue().message) ? this.contactForm.getRawValue().message : '',
            };
            this.contactService.create(params).subscribe(data => {
                this.successMessage = 'Your form has been submitted successfully!';
                this.submitted = false;
                this.contactForm.patchValue({
                    'name': '',
                    'email': '',
                    'contact': '',
                    'subject': '',
                    'message': ''
                });
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                    if (error['error']['errors'].subject && error['error']['errors'].subject.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].subject[0]);
                        return;
                    }
                    if (error['error']['errors'].message && error['error']['errors'].message.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].message[0]);
                        return;
                    }
                }
            });
        }
    }

    playVideo() {
        const video = this.videoElement.nativeElement;
        const thumbnail = document.getElementById('video-thumbnail');
        if (video) {
            video.classList.remove('d-none');
            video.play();
            if (thumbnail) {
                thumbnail.style.display = 'none';
            }
            const playButton = document.querySelector('.play-button');
            if (playButton) {
                playButton.classList.add('d-none');
            }
        }
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }


    nextSlide() {
        if (this.currentIndex < this.slidersItem.length - 1) {
            this.currentIndex++;
        }
    }

    prevSlide() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }
    }


    selectTab(index: number) {
        this.selectedIndex = index;
    }

    updateMetaTags() {
        this.title.setTitle('Grow your Business Digitally with best Mobile App Development Services');
        this.meta.updateTag({
            name: 'description',
            content: 'Make your business online digitally by stepping into the future of mobile technology with Volmint’s mobile app development services in India.'

        });
        this.meta.updateTag({
            name: 'keyword',
            content: 'flutter mobile app development, mobile application development company, app development for Android, app development for iOS, mobile application development cost\n'

        });
    }

}
